const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};

(function () {
  if (window.__teaQuizNavPatch >= 5) return;
  var base = '/cdn/shop/t/8/assets/';
  var ref = document.querySelector('script[src*="constants.js"]');
  if (ref && ref.src) base = ref.src.split('?')[0].replace(/constants\.js$/, '');
  var patch = document.createElement('script');
  patch.src = base + 'tea-quiz-nav-patch.js?_=' + Date.now();
  document.head.appendChild(patch);
})();
